// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"391":"ce3f52ac","667":"dad88202","764":"b79bd400","977":"89299236"}[chunkId] + ".chunk.js";
};